/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setBearerAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * FilterDefinitionValuesApi - axios parameter creator
 */
export const FilterDefinitionValuesApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Search the values of a filter definition (search, pagination and count options in the body)
     * @param {string} filterDefinitionId
     * @param {SearchFDVBody} searchFDVBody Search of the values of a filter definition. Everything travels in the body so a pasted list of codes is not bounded by the URL length
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchFilterDefinitionValues: (filterDefinitionId_1, searchFDVBody_1, ...args_1) =>
      __awaiter(
        this,
        [filterDefinitionId_1, searchFDVBody_1, ...args_1],
        void 0,
        function* (filterDefinitionId, searchFDVBody, options = {}) {
          // verify required parameter 'filterDefinitionId' is not null or undefined
          assertParamExists('searchFilterDefinitionValues', 'filterDefinitionId', filterDefinitionId);
          // verify required parameter 'searchFDVBody' is not null or undefined
          assertParamExists('searchFilterDefinitionValues', 'searchFDVBody', searchFDVBody);
          const localVarPath = `/api/filter-definition-value/{filterDefinitionId}/search`.replace(
            '{filterDefinitionId}',
            encodeURIComponent(String(filterDefinitionId))
          );
          // use dummy base URL string because the URL constructor only accepts absolute URLs.
          const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
          let baseOptions;
          if (configuration) {
            baseOptions = configuration.baseOptions;
          }
          const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
          const localVarHeaderParameter = {};
          const localVarQueryParameter = {};
          // authentication authorization required
          // http bearer authentication required
          yield setBearerAuthToObject(localVarHeaderParameter, configuration);
          localVarHeaderParameter['Content-Type'] = 'application/json';
          localVarHeaderParameter['Accept'] = 'application/json';
          setSearchParams(localVarUrlObj, localVarQueryParameter);
          let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
          localVarRequestOptions.headers = Object.assign(
            Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
            options.headers
          );
          localVarRequestOptions.data = serializeDataIfNeeded(searchFDVBody, localVarRequestOptions, configuration);
          return {
            url: toPathString(localVarUrlObj),
            options: localVarRequestOptions
          };
        }
      )
  };
};
/**
 * FilterDefinitionValuesApi - functional programming interface
 */
export const FilterDefinitionValuesApiFp = function (configuration) {
  const localVarAxiosParamCreator = FilterDefinitionValuesApiAxiosParamCreator(configuration);
  return {
    /**
     * Search the values of a filter definition (search, pagination and count options in the body)
     * @param {string} filterDefinitionId
     * @param {SearchFDVBody} searchFDVBody Search of the values of a filter definition. Everything travels in the body so a pasted list of codes is not bounded by the URL length
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchFilterDefinitionValues(filterDefinitionId, searchFDVBody, options) {
      return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const localVarAxiosArgs = yield localVarAxiosParamCreator.searchFilterDefinitionValues(
          filterDefinitionId,
          searchFDVBody,
          options
        );
        const localVarOperationServerIndex =
          (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null &&
          _a !== void 0
            ? _a
            : 0;
        const localVarOperationServerBasePath =
          (_c =
            (_b = operationServerMap['FilterDefinitionValuesApi.searchFilterDefinitionValues']) === null ||
            _b === void 0
              ? void 0
              : _b[localVarOperationServerIndex]) === null || _c === void 0
            ? void 0
            : _c.url;
        return (axios, basePath) =>
          createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
          )(axios, localVarOperationServerBasePath || basePath);
      });
    }
  };
};
/**
 * FilterDefinitionValuesApi - factory interface
 */
export const FilterDefinitionValuesApiFactory = function (configuration, basePath, axios) {
  const localVarFp = FilterDefinitionValuesApiFp(configuration);
  return {
    /**
     * Search the values of a filter definition (search, pagination and count options in the body)
     * @param {FilterDefinitionValuesApiSearchFilterDefinitionValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchFilterDefinitionValues(requestParameters, options) {
      return localVarFp
        .searchFilterDefinitionValues(requestParameters.filterDefinitionId, requestParameters.searchFDVBody, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * FilterDefinitionValuesApi - object-oriented interface
 */
export class FilterDefinitionValuesApi extends BaseAPI {
  /**
   * Search the values of a filter definition (search, pagination and count options in the body)
   * @param {FilterDefinitionValuesApiSearchFilterDefinitionValuesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  searchFilterDefinitionValues(requestParameters, options) {
    return FilterDefinitionValuesApiFp(this.configuration)
      .searchFilterDefinitionValues(requestParameters.filterDefinitionId, requestParameters.searchFDVBody, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
